import { CalendarClock } from "lucide-react";
import { formatSupportSlotTime } from "./supportSlots.js";

export interface SupportBookingCardBooking {
  id: string;
  starts_at: string;
  ends_at?: string;
}

/**
 * Billing-side twin of zenpost-frontend SupportBookingBanner:
 * shows the scheduled help slot with reschedule / cancel actions.
 */
export function SupportBookingCard({
  booking,
  locale,
  title,
  body,
  rescheduleLabel,
  cancelLabel,
  busy = false,
  onReschedule,
  onCancel,
}: {
  booking: SupportBookingCardBooking;
  locale: string;
  title: string;
  body: string;
  rescheduleLabel: string;
  cancelLabel: string;
  busy?: boolean;
  onReschedule?: () => void;
  onCancel?: () => void;
}) {
  const when = formatSupportSlotTime(booking.starts_at, locale);
  const bodyText = body.includes("{{time}}") ? body.replace("{{time}}", when) : body;

  return (
    <div className="card-glass p-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex gap-3 min-w-0">
        <span className="shrink-0 mt-0.5 text-purple-deep">
          <CalendarClock className="w-5 h-5" aria-hidden />
        </span>
        <div className="min-w-0 space-y-1">
          <div className="text-sm font-semibold text-[color:var(--text-primary)]">{title}</div>
          <p className="text-sm text-ink-2">{bodyText}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 sm:justify-end shrink-0">
        {onReschedule && (
          <button
            type="button"
            className="btn-ghost text-sm"
            disabled={busy}
            onClick={onReschedule}
          >
            {rescheduleLabel}
          </button>
        )}
        {onCancel && (
          <button
            type="button"
            className="btn-ghost text-sm"
            disabled={busy}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        )}
      </div>
    </div>
  );
}
